export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-200">404</h1>
        <p className="mt-4 text-xl font-semibold text-gray-900">Page not found</p>
        <p className="mt-2 text-gray-500">
          The booking page you&apos;re looking for doesn&apos;t exist.
        </p>
      </div>
    </div>
  );
}
